module.exports = __webpack_public_path__ + "static/media/icon-search.5f4a8844.svg";